// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateNewTransferNewDealer = (dealer) => ({
    dealer,
    type: actions.UPDATE_NEW_TRANSFER_NEW_DEALER,
});
